module.exports = __webpack_public_path__ + "img/thumbnail_CaliforniaSeaLion_f_albino.e11be570.png";